import { css } from "@emotion/react";
import { CSS_MQ } from "../../../styles/breakpoints";
import { CSS_COLORS } from "../../../styles/styles-css-variables";

export const pdpStickyStyles = css`
  position: sticky;
  top: var(--header-pinned-height);
`;

export const galleryWrapperStyles = css`
  ${CSS_MQ.atMostSm} {
    overflow-x: scroll;
    overflow-y: hidden;

    &.additional-margin {
      margin-bottom: 30px;
    }

    &::-webkit-scrollbar {
      height: 8px;
    }

    &::-webkit-scrollbar-track {
      background: ${CSS_COLORS.Grey0};
      border-radius: 6px;
    }

    &::-webkit-scrollbar-thumb {
      background: ${CSS_COLORS.Green};
      border-radius: 8px;
    }

    scroll-snap-type: x mandatory;

    > * > * {
      scroll-snap-align: start;
    }
  }
`;
